<template>
  <div class="leftNav">
    <el-row class="menu_page">
      <el-col>
        <el-menu
          mode="vertical"
          :default-active="$route.path"
          active-text-color="#A30815"
          class="el-menu-vertical-demo"
          :unique-opened="true"
          :collapse-transition="true"
        >
          <template v-for="item in this.menu">
            <el-submenu
              v-if="item.children"
              :index="String(item.id)"
              :key="item.id"
            >
              <template slot="title">
                <span slot="title">{{ item.name }}</span>
              </template>
              <router-link
                v-for="(citem, cindex) in item.children"
                :to="citem.path"
                :key="cindex"
              >
                <el-menu-item :index="citem.path">
                  <span slot="title">{{ citem.name }}</span>
                </el-menu-item>
              </router-link>
            </el-submenu>
            <router-link :to="item.path" :key="item.path" v-else>
              <el-menu-item :index="item.path">
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </router-link>
          </template>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "leftNav",
  props:["pand"],
  filters: {
    toString(value) {
      return value.toString();
    },
  },
  data() {
    return {
      data: [],
      menu: []
    }
  },
  methods: {
   
  },
  async created(){
      let that = this;
      await axios.get(this.COMMON.httpUrl + '/api/articleType/getChinaList', {
            }).then(function (response) {
              var data = response.data;
              if(data.code==200){
                that.menu = data.data;
              }
             
            }).catch(function (error) {
              console.log(error)
            });
      
  },
  mounted() {
    
  },
};
</script>

<style>
.leftNav {
  display: inline-block;
  width: 200px;
  /* background: #EFEFEF;  */
  background: #EFEFEF;
}
/* .el-menu{background: red;} */
.el-submenu__title{background: #EFEFEF;;}
.el-menu--inline{max-height: 200px; overflow-x:hidden;overflow-y:auto;background: #EFEFEF; }
a {
  text-decoration: none;
}
.el-menu {
  background: #EFEFEF;
}
.el-menu li{
  background: #FFF;
}
.el-menu li.is-active{background-color: #EFEFEF;}
.el-menu-item.is-active{color: #000;}
/* .el-submenu__title sapn{font-size:22px;} */
/* .el-menu li:hover{background-color: #EFEFEF;} */
</style>
